<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Panel Type</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <v-text-field
            v-model="item.code"
            :rules="[(v) => !!v && v.trim().length > 0 || 'Code is required']"
          >
            <template slot="label">
              Code<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <v-text-field
            v-model="item.description"
            label="Description"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-checkbox v-model="item.is_listed" label="Is Listed" />
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      code: '',
      is_manual: 0,
      description: '',
    },
  }),
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.wipPanelType.read(submitModel);
      if (!res || res.data < 1 || !res.data[0]) {
        this.$bus.$emit('showError', 'Unable to retrieve this item');
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async submit() {
      if (!this.item) return false;
      this.item.code = this.item.code.trim();
      if (!this.item.code) {
        this.$bus.$emit('showError', 'Code is required');
        return false;
      }
      let res;
      if (this.item.id) {
        res = await this.$api.wipPanelType.update(this.item);
      } else {
        res = await this.$api.wipPanelType.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
